var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.257,
    cy: 18.257,
    r: 18.257,
    fill: "#0766FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1688_12755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6493 27.2065V19.3691H22.2018L22.5847 16.3138H19.6493V14.3634C19.6493 13.4791 19.8867 12.8765 21.119 12.8765L22.688 12.8758V10.1431C22.4167 10.1067 21.4852 10.0234 20.4011 10.0234C18.1374 10.0234 16.5875 11.447 16.5875 14.0608V16.3138H14.0273V19.3691H16.5875V27.2065H19.6493Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1688_12755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17.1831,
    fill: "white",
    transform: "translate(9.85742 10.0234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.2ec74741af94586de26d24002bec5149.svg";
export { ForwardRef as ReactComponent };